module.exports = __webpack_public_path__ + "static/otyugh-448a7cadd2a9b0b05f991e1180c11fa5.jpeg";